import store from "./store";
import { startLoader, stopLoader } from "./actions/siteActions";
import { logoutUser } from "./actions/authActions";

// $startLoader and $stopLoader functions

export function $startLoader() {
  store.dispatch(startLoader());
}

export function $stopLoader() {
  store.dispatch(stopLoader());
}

export function $logoutUser() {
  localStorage.removeItem("authToken");
  localStorage.removeItem("user");
  store.dispatch(logoutUser());
}

export function $isLoggedIn() {
  const token = localStorage.getItem("authToken");
  if (!token) {
    return false;
  }
  return true;
}
